import { useState } from "react";
import NavBar from "../components/navBar";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.errors) {
          setFieldErrors(data.errors);
        } else {
          setFieldErrors({ email: data.message });
        }
        return;
      }

      // Store the token and user role in localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.user.userId);
      localStorage.setItem("userRole", data.user.role);
      localStorage.setItem("email", data.user.email); 

      // Redirect based on user role
      if (data.user.role === "admin") {
        window.location.href = "/admin-dashboard";
      } else {
        navigate("/home");
      }
    } catch (error) {
      console.error("Login error:", error);
      setFieldErrors({ email: "An error occurred during login" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NavBar />
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)]">
        <div className="w-full max-w-md p-8 shadow-lg rounded-lg">
          <h1 className="text-3xl font-bold text-center mb-6">Welcome Back!</h1>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-lg font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email address"
                className={`w-full py-2 px-4 border ${
                  fieldErrors.email ? "border-red-500" : "border-gray-300"
                } rounded-md focus:ring-2 focus:ring-red-500 focus:outline-none`}
              />
              {fieldErrors.email && (
                <p className="text-red-500 text-sm mt-1">{fieldErrors.email}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-lg font-medium mb-2"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Enter your password"
                className={`w-full py-2 px-4 border ${
                  fieldErrors.password ? "border-red-500" : "border-gray-300"
                } rounded-md focus:ring-2 focus:ring-red-500 focus:outline-none`}
              />
              {fieldErrors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {fieldErrors.password}
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-2 px-4 bg-red-600 text-white font-semibold rounded-md hover:bg-red-500 focus:ring-2 focus:ring-red-500 focus:outline-none disabled:bg-red-400 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Loading...
                </span>
              ) : (
                "Continue"
              )}
            </button>
          </form>
          <div className="mt-4 text-right">
            <a
              href="/forgot-password"
              className="text-red-500 font-medium hover:underline"
            >
              Forgot your password?
            </a>
          </div>
          <p className="mt-6 text-center">
            Don't have an account?{" "}
            <a
              href="/sign-up"
              className="text-red-500 font-medium hover:underline"
            >
              Sign up
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;
